import React, {useEffect, useState} from 'react'
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'
import SearchForm from './SearchForm/SearchForm'
import Results from './Results/Results'
import { postDataFetcher } from '../../dataFetcher'
import CONFIG_OBJECT from '../../config/config'
import App_Constants from '../../app-constants/App_Constants'
import RelatedItems from './RelatedItems/RelatedItems'
import Error from './Error/Error'
import Loader from './Loader/index'
import './Activity-SearchResult.css'
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';
import { isMobile } from 'react-device-detect';

const defaultitemperpage = 10

const ActivitySearchResult = (props) => {
  const [apidata, setApidata] = useState({
    data:'',
    totalCount: 1, 
    itemsPerPage: sessionStorage.getItem('pageperitem') ? sessionStorage.getItem('pageperitem') : 10, 
    numberOfPages: 1, 
    currentPage: 1,
    result:[],
    relatedItems:[],
    relatedItemsBlk: false,
    filtergroup:''
  })
  const [searchfieldText, setSearchfieldtext] = useState({
    text:sessionStorage.getItem('searchText') || '',
    resultdata: ''
  })

  const [filterData, setFilterData] = useState({
    groupdata: null
  })
  const [loader, setLoader] = useState(true)
  const [categorytext, setCategorytext] = useState('')
  const [pageSize, setPageSize] = useState()
  const [removeItem, setRemoveItem] = useState()
  const [filterlist, setFilterlist] = useState([])

  useEffect(() => {
    setLoader(true)    
    setPageSize(props.fields.pageSize && props.fields.pageSize)
    // console.log(localStorage.getItem('groupdata'))
    let data = {
      searchKeyword: sessionStorage.getItem('searchText') || searchfieldText.text,
      // searchKeyword: searchfieldText.text,
      PageNumber: apidata.currentPage,
      filterIDs: (filterData.groupdata ? JSON.stringify(filterData.groupdata) : null),
      itemsPerPage: sessionStorage.getItem('pageperitem') ? sessionStorage.getItem('pageperitem') : apidata.itemsPerPage
    }
    // if(localStorage.getItem('groupdata')){
    //   data.filterIDs = localStorage.getItem('groupdata')
    // }
    postDataFetcher(`${CONFIG_OBJECT.ACTIVITYFINDER_REST_URL}${App_Constants.SC_API_KEY}`, data)
    .then(res => {
      if (res.data.HasError) {
        console.log(res.data.HasError)
      } else {
        if(res.data.Data.pagination !== null){
          setLoader(false)
          setApidata({
            data: res.data.Data,
            totalCount: res.data.Data.pagination.totalCount, 
            itemsPerPage: res.data.Data.pagination.itemsPerPage, 
            numberOfPages: res.data.Data.pagination.numberOfPages,
            currentPage: res.data.Data.pagination.currentPage,
            result: res.data.Data.activities,
            relatedItems:res.data.Data.relatedItems,
            relatedItemsBlk: false,
            filtergroup: res.data.Data.filters
          },)
        } else {
          setLoader(false)
          setApidata({
            data:'',
            totalCount: 1, 
            itemsPerPage: defaultitemperpage, 
            numberOfPages: 1, 
            currentPage: 1,
            result:null,
            relatedItems: res.data.Data.relatedItems,
            relatedItemsBlk: true,
            filtergroup: null
          })
        }
      }
      // localStorage.setItem('searchText', '')
    }, err => {
      console.log(err);
    });
  }, [apidata.currentPage, searchfieldText.text, apidata.itemsPerPage,filterData.groupdata])  

  const paginate = (pagenumber) =>{
    setApidata({
      ...apidata,
      currentPage: pagenumber
    })
  }

  const getSearchFieldData = (searchtext) =>{
    sessionStorage.setItem('searchText', searchtext)
    setCategorytext('')
    setSearchfieldtext({
      text: searchtext
    })
    setApidata({
      ...apidata,
      itemsPerPage: defaultitemperpage,
      currentPage: 1,
    })
  }

  const getCategory = (category) =>{ 
    setCategorytext(category)
  }

  const itemsperpage = (itemcount) => {
    setApidata({
      ...apidata,
      itemsPerPage: itemcount,
      currentPage: 1
    })
  }

  const getFilterData = (data) => {
    // localStorage.setItem('groupdata',data)
    setFilterData({
      groupdata: data
    })
  }

  const clearallfilter = (data) => {
    sessionStorage.setItem('searchText', '')
    setRemoveItem(data)
  }

  const clearfilteritem = (itemtoremove) => {
    setRemoveItem(itemtoremove)
  }

  const getFilterlist = (data) => {
    //console.log(data)
    setFilterlist(data)
    //data.map((d, i) => combined.push(d))
    /* if(combined.indexOf(data[data.length - 1]) === -1){
      combined.push(data[data.length - 1])
    } else {
      combined.splice(combined.indexOf(data[data.length - 1]),1)
    }
    
    console.log(combined) */
    //setFilterlist(data, [...data])
  }

    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //---------------------------------------------

  return(
      <div className="container">

      <div className="ss-landing">
        <Placeholder
          name="social-share"
          rendering={props.rendering}
          itemid={props.itemid}
        />
      </div>
      {!isMobile && <p className="formintro" dangerouslySetInnerHTML={{ __html: props.fields.description.value }} />}

      {/* This is top level bar search filed with filters, inside it we have seperate 2 components */}
      <SearchForm 
        getSearchFieldData = {getSearchFieldData}
        apidata = {apidata}
        ritems = {apidata.relatedItems}
        categorytext = {categorytext !== '' && categorytext}
        filtergrouplabel={props.fields.filterGroup}
        filterData={getFilterData}
        removeitem={removeItem}
        filterlist={getFilterlist}
        searchtext={searchfieldText.text}
      />
      {
        loader ? <Loader /> : 
        apidata.result && (apidata.result !== null && apidata.result.length > 0) ?
        <>
          <Results 
            resultData = {apidata.result}
            paginate={paginate}
            paginatedata={apidata}
            pageSize = {pageSize}
            itemsperpage={itemsperpage}
            searchtext={searchfieldText.text}
            filters={apidata.filtergroup}
            resultfilterlist={filterlist}
            clearallfilter={clearallfilter}
            clearfilteritem={clearfilteritem}            
          />
        </>
        :
        apidata.relatedItems.length > 0 &&
        <div>
          <Error />
          <RelatedItems
            relateditems={apidata.relatedItems}
            category={getCategory}
          />
        </div>
      }       
    </div>
  )  
};

export default ActivitySearchResult;
